export enum VisibiliteFond {
    Inconnue = 0,
    BonneVisibilite = 1,
    MoyenneVisibilite = 2,
    FaibleVisibilite = 3,
    FondsNonVisibles = 4,
}
